export default __webpack_public_path__ + "static/taniyuk-horizontal-6ba526cb23e751f9bd4599af7322985a.png";